import { createApi } from "@reduxjs/toolkit/query/react"
import { PermissionDto } from "@custom-types/permission"
import { authQuery } from "./authQuery"

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: authQuery,
  tagTypes: ["Users"],
  endpoints: (builder) => ({
    getUserPermissions: builder.query<PermissionDto, string>({
      query: (key) => ({
        url: `/user/permissions/${key}`,
      }),
    }),
  }),
})

export const { useLazyGetUserPermissionsQuery } = userApi
